import { PUBLIC_CARDANO_NETWORK } from '$env/static/public';
import type { SupabaseGrabbit } from '$lib/supabase';
import {
	type Market,
	isCardanoContracts,
	isCardanoScriptReferences
} from './contract';

// TODO: This is rarely going to change and is a decent chunk of data so a good candidate for caching.
/**
 * There can be more than one active market whenever we change market terms because there could
 * be auctions running with the previous market terms.  Some time after all auctions in a given
 * market have closed and it is no longer in use the is_active flag is set to false because it
 * is considered inactive.
 * @returns Currently active markets for the applications configured cardano network.
 */
export default async function getActiveMarkets(
	supabase: SupabaseGrabbit
): Promise<Market[]> {
	const network = PUBLIC_CARDANO_NETWORK.toLowerCase();

	const { data } = await supabase
		.from('market')
		.select('*, cardano_contract(*), cardano_script_reference(*)')
		.eq('is_active', true)
		.eq('network', network)
		.order('create_time', { ascending: false });

	if (!data || data.length === 0) {
		return [];
	}

	const markets = [];
	for (const market of data) {
		const { cardano_contract, cardano_script_reference, ...rest } = market;
		const contracts: Record<string, string> = {};
		if (Array.isArray(cardano_contract)) {
			for (const { name, cbor_hex } of cardano_contract) {
				contracts[name] = cbor_hex;
			}
		}

		const scriptReferences: Record<string, string> = {};
		if (Array.isArray(cardano_script_reference)) {
			for (const { name, currency_symbol } of cardano_script_reference) {
				scriptReferences[name] = currency_symbol;
			}
		}

		if (
			isCardanoContracts(contracts) &&
			isCardanoScriptReferences(scriptReferences)
		) {
			markets.push({ ...rest, contracts, scriptReferences });
		} else {
			throw new Error('Database contracts not found for given market');
		}
	}

	return markets;
}
